import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import type { GridRowId } from "@mui/x-data-grid"

import type { DeviceWGroups } from "types/device.types"

import {
  getAddDevicesToGroupTableColumns,
  getAddDevicesToGroupTableRows,
} from "helpers/utils/addDevicesToGroupTable"
import DataGridTable from "widgets/common/DataGridTable"

interface AddDevicesToGroupTableProps {
  devices: DeviceWGroups[]
  selectedIds: number[]
  onSelectionChange: (deviceIds: number[]) => void
}

const AddDevicesToGroupTable = ({
  devices,
  selectedIds,
  onSelectionChange,
}: AddDevicesToGroupTableProps) => {
  const { t } = useTranslation()

  const columns = useMemo(() => getAddDevicesToGroupTableColumns(t), [t])
  const rows = useMemo(() => getAddDevicesToGroupTableRows(devices), [devices])

  return (
    <DataGridTable
      rows={rows}
      columns={columns}
      pageSize={5}
      sortModel={[{ field: "name", sort: "asc" }]}
      disableExport
      checkboxSelection
      selectedIds={selectedIds}
      onSelectionChange={(ids: GridRowId[]) => onSelectionChange(ids as number[])}
    />
  )
}

export default AddDevicesToGroupTable
